var app = angular.module('leonardo');

var AccountUserRoleService = function(BaseRestService) {
  var service = new BaseRestService('account-users-roles', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('account-users-roles', false, function(accountUser) {
      accountUser.addRestangularMethod('preDelete', 'post', 'pre-delete');
      accountUser.addRestangularMethod('cloneToWhiteLabel', 'post', 'clone-to-whitelabel');
      return accountUser;
    });
  });

  service.BASE_TYPE_OWNER = '0';
  service.BASE_TYPE_PROPERTY_MANAGER = '1';
  service.BASE_TYPE_EXTERNAL_MANAGER = '2';
  service.BASE_TYPE_SITE_STAFF = '3';
  service.BASE_TYPE_EXTERNAL_APPROVER = '4';

  return service;
};

app.factory('AccountUserRoleService', ['BaseRestService', AccountUserRoleService]);
